import React, { Component, Fragment } from 'react';
import { Button, Icon, Tag, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from "react-i18next";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import * as Func from "../../../../../helpers/functions";
import { PageListComponent, HeaderListComponent, ListComponent, FilterDropdown } from "../../../common/component/Index";
import Ripple from '../../../common/component/Ripple';
import { FlagIcons } from "../../../common/component/TranslateButton";
import { getOptions, getProperties, syncOptions } from '../../../../../actions/fnbAction';
import Wrapper from "../../../common/component/Wrapper";
import AntSelect, { AntOption } from "../../../common/component/AntSelect";
import Span from "../../../common/component/Span";

let permisionActions = {};
const pageSize = 10;

class Option extends Component {
    state = {
        filters: {
            PageIndex: 1,
            PageSize: pageSize,
        },
        propertyId: null,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);
        this.props.actions.getProperties();
        this.props.actions.getOptions(this.state.filters);
    }

    buildFilters = (pagination, filters, sorter) => {
        const currentFilters = this.state.filters || {};
        const hasNameKey = Object.prototype.hasOwnProperty.call(filters || {}, 'name');
        const hasStatusKey = Object.prototype.hasOwnProperty.call(filters || {}, 'isActive');
        const nameFilterRaw = filters?.name;
        const statusFilterRaw = filters?.isActive;
        const nameFilter = Array.isArray(nameFilterRaw) ? nameFilterRaw[0] : undefined;
        const statusFilter = Array.isArray(statusFilterRaw) ? statusFilterRaw[0] : undefined;
        const nameEmpty = typeof nameFilter === 'string' && nameFilter.trim() === '';
        const nameCleared = (hasNameKey && Array.isArray(nameFilterRaw) && nameFilterRaw.length === 0) || nameEmpty;
        const statusCleared = hasStatusKey && Array.isArray(statusFilterRaw) && statusFilterRaw.length === 0;
        const searchTerm = nameCleared
            ? undefined
            : (nameFilter === undefined || nameEmpty ? currentFilters.SearchTerm : nameFilter);
        const isActive = statusCleared ? undefined : (statusFilter !== undefined ? statusFilter : currentFilters.IsActive);
        const orderBy = sorter?.order ? sorter.field : undefined;
        const orderByDesc = sorter?.order ? sorter.order === 'descend' : undefined;
        const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
        const pageSizeValue = pagination?.pageSize || currentFilters.PageSize || pageSize;
        const changedFilters =
            searchTerm !== currentFilters.SearchTerm ||
            isActive !== currentFilters.IsActive ||
            orderBy !== currentFilters.OrderBy ||
            orderByDesc !== currentFilters.OrderByDesc;
        return Func.removeObjectNull({
            PageIndex: changedFilters ? 1 : pageIndex,
            PageSize: pageSizeValue,
            SearchTerm: searchTerm,
            IsActive: isActive,
            PropertyId: currentFilters.PropertyId,
            OrderBy: orderBy,
            OrderByDesc: orderByDesc,
        });
    };

    handleChange = (pagination, filters, sorter) => {
        const nextFilters = this.buildFilters(pagination, filters, sorter);
        this.setState({ filters: nextFilters });
        this.props.actions.getOptions(nextFilters);
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(
            (option?.props?.children || '')?.toString().toLowerCase()
        );
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onChangeProperty = (value) => {
        const nextFilters = Func.removeObjectNull({
            ...this.state.filters,
            PageIndex: 1,
            PropertyId: value ?? null,
        });
        this.setState({ filters: nextFilters, propertyId: value ?? null });
        this.props.actions.getOptions(nextFilters);
    };

    render() {
        const { t, options, optionsPagination, loading, properties, optionSyncing } = this.props;
        const canSync = permisionActions && permisionActions.allowSync;
        const { filters, propertyId } = this.state;
        const pageIndex = optionsPagination?.pageIndex || filters.PageIndex || 1;
        const pageSizeValue = optionsPagination?.pageSize || filters.PageSize || pageSize;
        const propertyList = properties || [];
        const columns = [
            {
                title: t('item.fnb.option.code'),
                dataIndex: 'code',
                key: 'code',
                sorter: true,
            },
            {
                title: t('item.fnb.option.name'),
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                )
            },
            {
                title: 'Required',
                dataIndex: 'isRequired',
                key: 'isRequired',
                render: (isRequired) => (
                    isRequired ? <Tag color="orange">Yes</Tag> : <Tag>No</Tag>
                )
            },
            { title: 'Level', dataIndex: 'level', key: 'level', sorter: true },
            { title: 'Order', dataIndex: 'order', key: 'order', sorter: true },
            {
                title: t('item.fnb.menu.status'),
                dataIndex: 'isActive',
                key: 'isActive',
                filters: [
                    { value: true, text: t('item.fnb.menu.active') },
                    { value: false, text: t('item.fnb.menu.inactive') },
                ],
                filterMultiple: false,
                filteredValue: filters.IsActive !== undefined ? [filters.IsActive] : null,
                render: (isActive, record) => {
                    const active =
                        typeof isActive === 'boolean' ? isActive : Boolean(record.status);
                    return active
                        ? <Tag color="green">{t('item.fnb.menu.active')}</Tag>
                        : <Tag color="red">{t('item.fnb.menu.inactive')}</Tag>;
                }
            },
            {
                title: t('item.fnb.option.translations'),
                dataIndex: 'translations',
                key: 'translations',
                render: (translations) => <FlagIcons languages={translations || []} />
            },
            {
                title: t('action.action'),
                key: 'action',
                align: 'right',
                render: (text, record) => (
                    <Link to={Func.getPathWithParams(PATHS.FNB.OPTION_MANAGER.DETAIL.path, { id: record.id })}>
                        <Icon type="form" className="fs20 colorPrimary" />
                    </Link>
                )
            },
        ];

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        titleHeader={t('navigation.option')}
                        extraBreadcrumbs={[{ title: t('navigation.option') }]}
                        componentRight={
                            canSync && propertyId ? (
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button
                                        icon="sync"
                                        className="btn btn-primary"
                                        loading={optionSyncing}
                                        onClick={this.onSync}
                                    >
                                        {t('action.sync')}
                                    </Button>
                                </Ripple>
                            ) : null
                        }
                    />
                    <Wrapper className="row col-md-12 p-2" style={{ marginBottom: "1rem" }}>
                        <Wrapper className="col-md-4">
                            <Span>{t('item.property.title') || 'Property'}:</Span>
                            <AntSelect
                                className="select-departure"
                                showArrow
                                showSearch
                                allowClear
                                placeholder={t('item.property.title') || 'Property'}
                                value={propertyId}
                                onChange={this.onChangeProperty}
                                style={{ width: "100%" }}
                                filterOption={this.selectFilterSearch}
                            >
                                <AntOption value={null}>Tất cả</AntOption>
                                {(propertyList || []).map((property) => (
                                    <AntOption key={property.id} value={property.id}>
                                        {property.name || property.code || property.id}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </Wrapper>
                    </Wrapper>
                    <ListComponent
                        tableKey="option-list"
                        classChildren="p-0"
                        classParent="m-0"
                        rowKey={(record, index) => record.id || index}
                        loading={{ spinning: loading, size: "large" }}
                        dataSource={options || []}
                        columns={columns}
                        onChange={this.handleChange}
                        pagination={{
                            total: optionsPagination?.totalCount || 0,
                            totalPage: optionsPagination?.totalPage || 0,
                            defaultCurrent: pageIndex,
                            defaultPageSize: pageSizeValue,
                        }}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onSync = () => {
        const { t } = this.props;
        const { propertyId, filters } = this.state;
        if (!propertyId) {
            return;
        }
        Modal.confirm({
            title: t('action.sync'),
            content: t('notification.confirmSyncDataOption') || 'Bạn có chắc chắn muốn đồng bộ dữ liệu?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.syncOptions({ propertyId, filters });
            },
        });
    };
}

const mapStateToProps = (state) => ({
    options: state.fnbReducer.options,
    optionsPagination: state.fnbReducer.optionsPagination,
    loading: state.fnbReducer.loading,
    properties: state.fnbReducer.properties,
    optionSyncing: state.fnbReducer.optionSyncing,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getOptions,
            getProperties,
            syncOptions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Option));
